import { render, staticRenderFns } from "./MailingsLists.vue?vue&type=template&id=8ccb1f58&scoped=true&"
import script from "./MailingsLists.vue?vue&type=script&lang=ts&"
export * from "./MailingsLists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccb1f58",
  null
  
)

export default component.exports